<template>
	<div class="loader-with-title">
		<animated-title />
	</div>
</template>

<script>
import AnimatedTitle from '@/components/Loaders/AnimatedTitle.vue'

export default {
	name: 'LoaderWithTitle',

	components: {
		AnimatedTitle
	}
}
</script>

<style lang="scss">
.loader-with-title {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.6);
}
</style>
